import React, {Component} from "react"
import styled from "styled-components"

import ProfilePic from "@irati/ui/src/ProfilePicture"
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname"
import {User} from "@irati/types"
import {IconButton, IconTypes} from "@irati/ui/src/Button"
import {Body} from "@irati/ui/src/Typography"
import id from "@irati/utils/id"
import authentication from "@irati/auth"
import RewardWalletBalanceQuery, {RewardWalletBalanceData} from "@irati/wallet/apollo/query/RewardWallet"

import RewardWalletUsersBalanceCard from "./RewardWalletUsersBalanceCard"

interface Props {
  removeUser(user: User): void
  user: User
  index: number
}

const FlexRow = styled.div`
  border-bottom: 1px solid ${({theme}) => theme.colors.greys.light};
  margin-bottom: ${({theme}) => theme.spacing.one};
  padding: 5px 0;
  align-items: center;
  display: flex;
  justify-content: space-between;
`

const StyledProfilePic = styled(ProfilePic)`
  margin-right: 10px;
  margin-bottom: 15px;
`

const StyledUser = styled.div`
  width: calc(100% - 90px);
`

const StyledButton = styled(IconButton)`
  width: 20px;
`

class SelectedManager extends Component<Props> {
  static defaultProps = {
    id: "rewardRecipientsList"
  }

  returnRewardWalletBalanceVariables = (user: User) => ({
    currency: authentication.defaultUserCurrency(),
    tenantId: authentication.userTenant().uuid,
    userId: user.uuid
  })

  render() {
    const {removeUser, user, index} = this.props
    return (
      <RewardWalletBalanceQuery variables={this.returnRewardWalletBalanceVariables(user)}>
        {({data: {rewardWallet}}: RewardWalletBalanceData) => {
          return (
            <FlexRow id={id(`recipient${index}`, this.props)}>
              <StyledProfilePic user={user} regular />
              <StyledUser>
                <Body large maxWidth="100%" marginBottom={1} weight="bold">
                  {firstnameLastname(user)}
                </Body>
                <RewardWalletUsersBalanceCard rewardWallet={rewardWallet} />
              </StyledUser>
              <StyledButton icon={IconTypes.cross} onClick={() => removeUser(user)} />
            </FlexRow>
          )
        }}
      </RewardWalletBalanceQuery>
    )
  }
}

export default SelectedManager
